var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
// components
import { StyledLabel } from "./label.styles";
import { StyledInput, StyledInputSwitch } from "./input.styles";
// utils
import { makeDataTestIdGetter } from "../utils";
export const Switch = (_a) => {
    var { id, disabled, checked, dataTestIdPrefix, onChange } = _a, restProps = __rest(_a, ["id", "disabled", "checked", "dataTestIdPrefix", "onChange"]);
    const [focused, setFocused] = useState(false);
    const [active, setActive] = useState(false);
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    return (_jsxs(StyledLabel, Object.assign({ htmlFor: id, onMouseDown: () => setActive(true), onMouseUp: () => setActive(false) }, restProps, { children: [_jsx(StyledInput, Object.assign({ type: "checkbox", id: id, disabled: disabled, onMouseDown: () => setFocused(false), onKeyUp: () => setFocused(true), onBlur: () => setFocused(false), focused: focused }, (typeof onChange === "function"
                ? { onChange, checked }
                : { defaultChecked: checked }), { "data-testid": getDataTestId("switch-input") })), _jsx(StyledInputSwitch, { active: active })] })));
};
